module.exports = __webpack_public_path__ + "static/img/bg_image.8a37423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_image.png
// module id = R5ob
// module chunks = 0